import { ActivatedRoute, RouterLinkActive, RouterLink } from '@angular/router';
import { Component, inject, OnInit } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

import * as RoutesDefinitions from '../../../routes-definitions';

@Component({
	selector: 'menu-links',
	templateUrl: './menu-links.component.html',
	imports: [RouterLinkActive, RouterLink, TranslateDirective]
})
export class MenuLinksComponent implements OnInit {

	private route = inject(ActivatedRoute)

	federationId: number;
	federationsPath = RoutesDefinitions.getFederationsFullPath();

	ngOnInit() {
		this.federationId = this.route.snapshot.params.id;
	}


	get federationDetailPath() {
		return RoutesDefinitions.getFederationDetailFullPath(this.federationId);
	}

	get federationDetailUsersPath() {
		return RoutesDefinitions.getFederationDetailUsersFullPath(this.federationId);
	}

}
